import styled from 'styled-components';

export const SubHeader= styled.h2`
  color: rgba(0, 0, 0, 0.60);
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
`